import React from 'react';
import { useParams } from 'react-router-dom';
import Call from './Call';
import '../App.css'; 
import { auth } from '../firebase';

function CallWrapper() {
  const { roomName } = useParams();
  const displayName = auth.currentUser?.email || 'Anonymous';
  const userId = auth.currentUser?.uid;

  return (
    <div style={{ height: '100vh' }}>
      <Call roomName={roomName} displayName={displayName} mentorId={userId} />
    </div>
  );
}

export default CallWrapper;
